import { Routes, Route, HashRouter } from 'react-router-dom';

import LoginScreen from '../screen/LoginScreen';
import DashBoard from './DashBoard';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

export default function AppRouter() {
	return (
		<HashRouter>
			<Routes>
				<Route
					path='/login'
					element={
						<PublicRoute>
							<LoginScreen />
						</PublicRoute>
					}
				/>

				<Route
					path='/*'
					element={
						<PrivateRoute>
							<DashBoard />
						</PrivateRoute>
					}
				/>
			</Routes>
		</HashRouter>
	);
}
